const SEPARATOR_RUN = /[\s·-]+/g;

const collapseSeparators = (value: string): string => value.replace(SEPARATOR_RUN, " ").trim();

export const tokenizeSearchTerm = (searchTerm: string): string[] =>
	collapseSeparators(searchTerm)
		.split(" ")
		.filter((token) => token.length > 0);

const matchesAllSearchTokens = (searchableValues: (string | null | undefined)[], searchTerm: string): boolean => {
	const tokens = tokenizeSearchTerm(searchTerm.toLowerCase());
	if (tokens.length === 0) return true;
	const haystacks = searchableValues
		.filter((value): value is string => Boolean(value))
		.map((value) => collapseSeparators(value.toLowerCase()));
	return tokens.every((token) => haystacks.some((haystack) => haystack.includes(token)));
};

export default matchesAllSearchTokens;
